import { Icon }  from 'leaflet'
import 'leaflet/dist/leaflet.css'
import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'
import Toasted from 'vue-toasted'

// Filters
import intToStringPing from '@/filters/estadosPingUp'
import intToString from '@/filters/estados'
import tipoToStringPing from '@/filters/tipos'
import categoriaToString from '@/filters/categoria'
import unidadToString from '@/filters/unidad'
import concatNombreSubClase from '@/filters/tiposDevice.js'
import estadosInvStr from '@/filters/estadosInventario.js'
import VueCurrencyFilter from 'vue-currency-filter'
import VueSignaturePad from  'vue-signature-pad'
import numberToFormat from '@/filters/numbers.js'

import routes from '@/routes'
import store from '@/store'

Vue.use(VueRouter)
Vue.use(intToStringPing)
Vue.use(intToString)
Vue.use(tipoToStringPing)
Vue.use(categoriaToString)
Vue.use(unidadToString)
Vue.use(concatNombreSubClase)
Vue.use(estadosInvStr)
Vue.use(numberToFormat)
Vue.use(Toasted)
Vue.use(VueCurrencyFilter, {
  symbol : '$',
  thousandsSeparator: ',',
  fractionCount: 2,
  fractionSeparator: '.',
  symbolPosition: 'front',
  symbolSpacing: true
})
Vue.use(VueSignaturePad)

delete Icon.Default.prototype._getIconUrl

Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})

const router = new VueRouter({
  routes,
  mode: 'history'
})

new Vue({
  el: '#app',
  render: h => h(App),
  router,
  store
})



// WEBPACK FOOTER //
// ./src/main.js